import Joi from 'joi';
import { isNumber } from '../../../../helpers/OnlyNumbers';

const giftCardNumberValidator = Joi.extend({
  messages: {
    invalidNumber: 'Ingresa 7 o 20 dígitos',
  },
  type: 'string',
  rules: {
    validateNumber: {
      validate(value, helpers) {
        if (isNumber(value) && (value.length === 7 || value.length === 20))
          return true;
        else return helpers.error('invalidNumber');
      },
    },
  },
});

export const schema = Joi.object({
  giftCardNumber: giftCardNumberValidator.string().validateNumber(),
});
